/**
 * Navigates back to the site that redirected the user into the workbench
 * (e.g. the CAPS work queue), using the per-environment `VITE_EXIT_CAPS_STEP6_URL`.
 * No-ops when unset (local/lab dev has no real origin site to return to).
 * @returns {void}
 */
export function redirectToOriginSite(): void {
  const url = import.meta.env.VITE_EXIT_CAPS_STEP6_URL;
  if (!url) {
    return;
  }
  globalThis.location.assign(url);
}
